<template>
  <BaseDialog
    v-model="showDialog"
    :title="title"
    :subtitle="subtitle"
    dialogIcon="mdi-certificate-outline"
    btnActionName="Lagre"
    :persistent="persistent"
    scrollable
    @action="save"
  >
    <template v-slot>
      <div v-if="coursesLoading" class="text-center pb-4">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <div v-else>
        <span v-if="coursesToSelect.length > 0">Kompetanse</span>
        <v-divider v-if="coursesToSelect.length > 0"></v-divider>
        <v-card-text class="pt-0 px-0">
          <v-form ref="form" v-model="valid" autocomplete="off">
            <div v-for="(item, index) in coursesToSelect" :key="index">
              <v-checkbox
                v-model="item.selected"
                hide-details
                :label="item.name"
              ></v-checkbox>
              <div v-if="item.hasExpiryDate && item.selected" class="mt-4">
                <ExpiryDateDialog
                  v-model="item.expiryDate"
                  label="Utgår"
                  :rules="[(v) => !!v || 'Dato må fylles ut!']"
                />
              </div>
            </div>
          </v-form>

          <div v-if="showSelected">
            <span v-if="coursesContactPerson.length > 0">Dine kompetanser</span>
            <CompetenceList :courses="coursesContactPerson" />
          </div>
        </v-card-text>
      </div>
    </template>
  </BaseDialog>
</template>

<script lang="ts">
import Vue from "vue";
import notification from "@/helpers/notification";

import { mapActions, mapGetters } from "vuex";

import BaseDialog from "@/components/shared/dialog/BaseDialog.vue";
import ExpiryDateDialog from "@/components/shared/date/ExpiryDateDialog.vue";
import CompetenceList from "@/components/profile/children/CompetenceList.vue";

export default Vue.extend({
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    persistent: {
      type: Boolean,
      default: false,
    },
    showSelected: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Kurs og sertifikater",
    },
    subtitle: {
      type: String,
      default: "Kryss av for dine kompetanser",
    },
  },
  data() {
    return {
      valid: true,
    };
  },
  methods: {
    ...mapActions({
      addCourse: "courses/addCourse",
    }),
    async save() {
      const isValid = (this as any).$refs?.form?.validate();
      if (isValid) {
        await this.addCourse(this.coursesToSelect).then(() => {
          this.showDialog = false;
          this.$emit("save");
        });
      } else {
        notification.warn("Utgående dato må fulles ut!");
      }
    },
  },

  computed: {
    ...mapGetters({
      coursesLoading: "courses/coursesLoading",
      coursesContactPerson: "courses/coursesContactPerson",
      coursesToSelect: "courses/coursesToSelect",
    }),
    showDialog: {
      get(): boolean {
        return this.value;
      },
      set(value: boolean) {
        this.$emit("input", value);
      },
    },
  },
  components: {
    BaseDialog,
    ExpiryDateDialog,
    CompetenceList,
  },
});
</script>
